import { Theme } from '@mui/material/styles';

/** Optional `solid` makes background opaque for sticky headers so body content doesn't show through on scroll. */
export const getTableHeaderStyles = (isDarkMode: boolean, solid?: boolean) => ({
  fontWeight: 'bold',
  backgroundColor: solid
    ? isDarkMode
      ? 'rgb(18, 32, 48)' // opaque equivalent of rgba(25, 118, 210, 0.12) on dark
      : 'rgb(237, 248, 253)' // opaque equivalent of rgba(25, 118, 210, 0.08) on white
    : isDarkMode
      ? 'rgba(25, 118, 210, 0.12)'
      : 'rgba(25, 118, 210, 0.08)',
  color: isDarkMode ? 'primary.light' : 'primary.main',
});

export const getTableContainerStyles = () => ({
  width: '100%',
  overflow: 'hidden',
});

export const getStatusChipStyles = (isActive: boolean) => ({
  size: 'small' as const,
  variant: 'outlined' as const,
  color: isActive ? 'success' : 'error',
  icon: isActive ? 'CheckCircle' : 'Cancel',
  label: isActive ? 'Active' : 'Expired',
});

// Helper function to format status text with proper capitalization
export const formatStatusText = (status: string) => {
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

export const getTableRowStyles = () => ({
  '&:last-child td, &:last-child th': { border: 0 },
});

export const getTableCellStyles = () => ({
  padding: '12px 16px',
});

export const getTablePaginationStyles = () => ({
  borderTop: '1px solid',
  borderColor: 'divider',
}); 